import React, { useEffect, useRef, useState } from 'react';
import './statusprogres.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import CoinsPopup from './CoinsPopup';
import HeartPopup from './HeartPopup';
import PopupQuestion from './PopupQuestion';


// 🔥 Tipurile care NU trebuie să actualizeze progresul
const noTransitionTypes = [
  "lessonResume",
  "JustInTimeMotivation",
  "serieCompleta",
  "deblocarePremium",
  "clasament"
];

// 🔥 Tipurile care au elementele dezactivate
const disabledElementsTypes = ['explanationLesson', 'lessonCompletion'];


const StatusProgres = ({ 
  width, 
  onExitClick, 
  coinCount, 
  lessonCoinsEarned = 0,
  hideCoinsPopup = false,
  livesCount,
  lessonType,         // ← primit din Chaptercontainer
  showCardDots = false,
  totalCards = 0,
  activeCardIndex = 0,
  onCardDotClick,
  onProgressAnimationStateChange,
  quizExplanation,
  onRevealAnswer,
  isContextShowing = false,  // ← true când contextul decisionFlowApplication este afișat
  disableHeaderElements = false // ← nou: dezactivează HELP, coins, inimioare
}) => {

  const [progress, setProgress] = useState(width);
  const [displayedCoinCount, setDisplayedCoinCount] = useState(coinCount);
  const [isCoinAnimating, setIsCoinAnimating] = useState(false);
  const previousWidthRef = useRef(width);
  const isProgressAnimatingRef = useRef(false);


  // 🔥 Sincronizăm bara de progres doar după terminarea animației reale de width
  useEffect(() => {
    if (noTransitionTypes.includes(lessonType)) {
      isProgressAnimatingRef.current = false;
      setProgress(width);
      previousWidthRef.current = width;
      onProgressAnimationStateChange?.(true);
      return;
    }

    const widthChanged = previousWidthRef.current !== width;

    if (widthChanged) {
      isProgressAnimatingRef.current = true;
      onProgressAnimationStateChange?.(false);
    } else {
      isProgressAnimatingRef.current = false;
      onProgressAnimationStateChange?.(true);
    }

    setProgress(width);
    previousWidthRef.current = width;
  }, [width, lessonType, onProgressAnimationStateChange]);


  // 🔥 STOP animație progres la tipurile speciale
  useEffect(() => {
    if (noTransitionTypes.includes(lessonType)) return;

    setProgress(width);

    const rangeEl = document.querySelector('.progress-bar-range');
    if (rangeEl) {
      rangeEl.classList.add('moving');
      setTimeout(() => rangeEl.classList.remove('moving'), 600);
    }
  }, [width, lessonType]);


  // ANIMAȚIE COINS
  useEffect(() => {
    if (coinCount > displayedCoinCount) {
      setIsCoinAnimating(true);

      const timer = setTimeout(() => {
        setIsCoinAnimating(false);
        setDisplayedCoinCount(coinCount);
      }, 300);

      return () => clearTimeout(timer);
    } else {
      setDisplayedCoinCount(coinCount);
    }
  }, [coinCount, displayedCoinCount]);


  return (
    <div className='general-section-progress-bar'>
      <div className='first-elements-header-progress-bar'>
        
        {/* Butoane & coin/lives */}
        <div className='bar-progress-elemnts'>
          
          <div className='exit-lesson-name dim-prog-bar-1'>
            <FontAwesomeIcon
              icon={faTimes}
              className='arrow-change-lesson-x'
              onClick={onExitClick}
            />
          </div>
          
          <div 
            className={`tracking-elements${(disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements) ? ' disabled' : ''}`}
            style={(disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements) ? { pointerEvents: 'none', opacity: 0.5 } : {}}
          >
            <div
              className={`question-tracking${(disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements) ? ' disabled' : ''}`}
              aria-disabled={disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements}
              tabIndex={(disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements) ? -1 : 0}
              style={(disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements) ? { pointerEvents: 'none', opacity: 0.5 } : {}}
            >
              <PopupQuestion quizExplanation={quizExplanation} coinCount={displayedCoinCount} onRevealAnswer={onRevealAnswer} />
            </div>
            {!hideCoinsPopup && (
              <div className={`coin-wrap ${isCoinAnimating ? 'bounce-animation' : ''}${(disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements) ? ' disabled' : ''}`}>
                <CoinsPopup coinCount={displayedCoinCount} lessonCoinsEarned={lessonCoinsEarned} />
              </div>
            )}
            <div className={`lives-tracking${(disabledElementsTypes.includes(lessonType) || isContextShowing || disableHeaderElements) ? ' disabled' : ''}`}>
              <HeartPopup livesCount={livesCount} />
            </div>
          </div>
        </div>

        
        {/* 🔥 ASCUNDEM PROGRESUL PENTRU TIPURILE SPECIALE */}
        {!noTransitionTypes.includes(lessonType) && (
          <div className='section-progress-bar-lesson'>
            <div className='progress-bar-container'>

              <div className='progress-bar-track' />

              <div
                className='progress-bar-background'
                style={{ width: `${progress}%` }}
                onTransitionEnd={(event) => {
                  if (event.propertyName === 'width' && isProgressAnimatingRef.current) {
                    isProgressAnimatingRef.current = false;
                    onProgressAnimationStateChange?.(true);
                  }
                }}
              />

              <div
                className='progress-bar-background-line'
                style={{ width: `${progress}%` }}
              />

            </div>

            {showCardDots && totalCards > 1 && (
              <div className='progress-card-dots' role='tablist' aria-label='Navigare carduri'>
                {Array.from({ length: totalCards }).map((_, i) => (
                  <button
                    key={i}
                    type='button'
                    className={`progress-card-dot ${i === activeCardIndex ? 'active' : ''}`}
                    onClick={() => onCardDotClick?.(i)}
                    aria-label={`Card ${i + 1}`}
                    aria-selected={i === activeCardIndex}
                  />
                ))}
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

export default StatusProgres;
